import { api } from "../../shared/api/client";
import type {
  KycApproveResponse,
  KycCorrectionResponse,
  KycDecisionRequest,
  KycQueueResponse,
  KycStatus,
  KycSubmissionDetailResponse,
} from "./types";

/**
 * Office-domain API calls (customer-service, /api/v1 base).
 * Endpoints and shapes per contracts/api/v1/kyc.yaml.
 */

export function listKycSubmissions(status?: KycStatus) {
  const qs = status ? `?status=${encodeURIComponent(status)}` : "";
  return api.get<KycQueueResponse>(`/kyc/submissions${qs}`);
}

export function getKycSubmission(id: number) {
  return api.get<KycSubmissionDetailResponse>(`/kyc/submissions/${id}`);
}

/** Decisions are idempotent server-side via the Idempotency-Key header. */
export function decideKycSubmission(
  id: number,
  body: KycDecisionRequest,
  idempotencyKey: string,
) {
  return api.post<KycApproveResponse | KycCorrectionResponse>(
    `/kyc/submissions/${id}/decision`,
    body,
    idempotencyKey,
  );
}

/**
 * Mask a NIDA number for display — mirrors `_mask_nida` in customer-service
 * (first 4 + last 2 characters visible). Applied client-side because the
 * detail endpoint's payload snapshot is intentionally unmasked.
 */
export function maskNida(nida: string | null | undefined): string {
  if (!nida) return "—";
  const s = String(nida);
  if (s.length <= 6) return s;
  return `${s.slice(0, 4)}${"#".repeat(s.length - 6)}${s.slice(-2)}`;
}
